export default {
  frontRoutes: [
    {
      path: '/library',
      name: 'LibraryList',
      component: () => import(/* webpackChunkName: "library" */ '../views/library/LibraryList.vue'),
    },
    {
      path: '/library/:id',
      name: 'LibraryDetail',
      component: () =>
        import(/* webpackChunkName: "library" */ '../views/library/LibraryDetail.vue'),
      meta: {
        requireAuth: true,
      },
    },
  ],
  memberRoutes: [],
};
